module.exports = __webpack_public_path__ + "static/rostele_logo_rus_whi-9e01d8639159f75c21c4eee989c6b1b1.png";